require('./cardLastMovementsContent.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @utilities
const { getLastNChars } = require('utilities/stringHelper');
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');

// @components
const CardLastMovementsContentFilters = require('components/cards/cardLastMovements/cardLastMovementsContent/cardLastMovementsContentFilters/cardLastMovementsContentFilters');
const CardLastMovementsHeader = require('components/cards/cardLastMovements/cardLastMovementsHeader/cardLastMovementsHeader');
const CardLastMovementsTable = require('components/cards/cardLastMovements/cardLastMovementsTable/cardLastMovementsTable');
const DownloadFileModal = require('components/commons/downloadFileModal/downloadFileModal');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const Sca = require('components/sca/sca');
const ScaDownloadMovements = require('components/sca/scaDownloadMovements');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { recordLink } = require('utilities/tagging');

// @constants
const { VIEWER } = require('constants/contactCenter/pdfViewer');
const { HYPHEN } = require('constants/index');
const { CHECK_TYPES_FILE } = require('constants/fileRequirements');
const { MORE_MOVEMENTS_ACTION_EVENT, MORE_MOVEMENTS_EVENT_TAG } = require('constants/tagging');
const { LAVANDA } = require('constants/flagBasedFeatures');


class CardLastMovementsContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            downloadModalOpen: false,
        };

        this.buildConectionError = this.buildConectionError.bind(this);
        this.buildDownloadButton = this.buildDownloadButton.bind(this);
        this.buildEmptyState = this.buildEmptyState.bind(this);
        this.buildNextPageButton = this.buildNextPageButton.bind(this);
        this.buildSca = this.buildSca.bind(this);
        this.buildTableElementSection = this.buildTableElementSection.bind(this);
        this.cardsTransactionsDownloadAsPDF = this.cardsTransactionsDownloadAsPDF.bind(this);
        this.cardsTransactionsDownloadAsXLS = this.cardsTransactionsDownloadAsXLS.bind(this);
        this.handleCardsDropdownChange = this.handleCardsDropdownChange.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handleOpenPDFViewer = this.handleOpenPDFViewer.bind(this);
        this.handlePostRequest = this.handlePostRequest.bind(this);
        this.handleToggleDownloadModal = this.handleToggleDownloadModal.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        this.sca = React.createRef();
    }

    buildConectionError() {
        const { onRetry } = this.props;
        const lostConnectionFirstLine = formatText('myMoneyTransactions-lostConnectionFirstLine');
        const retryButton = (
            <OKButton onClick={onRetry}>
                <FormattedText value="myMoneyTransactions-retry" />
            </OKButton>
        );
        return <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-banking"/>;
    }

    buildDownloadButton() {
        const { immCardsTransactionsDownload } = this.props;
        const loading = immCardsTransactionsDownload.get('inProgress');
        const handleClick = __CONTACT_CENTER__ ? this.handleOpenPDFViewer : this.handleToggleDownloadModal;
        const downloadButton = (
            <div className="card-last-movements-content__download-button-container">
                <OKButton
                    id="btnDownloadCardTransactions"
                    loading={loading}
                    onClick={handleClick}
                    modifier="task"
                    loaderSize="small"
                >
                    <i className={conditionalClassName("icon-descargar", "icon-mostrar icon-modifier-regular", "icon")} />
                </OKButton>
            </div>
        );
        const contentTooltip = __CONTACT_CENTER__ ? "cards-previewIcon" : "cards-downloadIcon";
        return (
            <OKTooltip
                content={contentTooltip}
                modifier="dark-bg"
                offset={[0, -15]}
                target={downloadButton}
            />
        );
    }

    buildEmptyState() {
        const { immFilters, immTransactions } = this.props;
        if (!immTransactions.get('scaRequired')) {
            const activeFilters = immFilters.getIn(['date', 'isActive'])
                || immFilters.getIn(['situation', 'isActive'])
                || immFilters.getIn(['state', 'isActive']);
            const messageKey = activeFilters ? 'cards-noResultsWithFilters' : 'cards-noResults';
            const primaryText = formatText(messageKey);
            return (
                <EmptyState
                    primaryText={primaryText}
                    iconType="search-banking"
                />
            );
        }
        return this.buildSca();
    }

    buildNextPageButton() {
        return (
            <div className="card-last-movements-content__button-container">
                <OKButton onClick={this.handleNextPage} modifier="link-complementary">
                    <FormattedText
                        value="cards-seeMoreMovements"
                        format={__CONTACT_CENTER__ ? "uppercase" : undefined}
                    />
                </OKButton>
            </div>
        );
    }

    buildCardsDropdown(pageContent) {
        const { immCard, immCards, immTransactions } = this.props;
        const optionsArr = [];
        immCards.get('byOrder').forEach(cardId => {
            const immCurrentCard = immCards.getIn(['byId', cardId]);
            if (immCurrentCard.get('fullContractNumber') === immCard.get('fullContractNumber')){
                const aliasText = immCurrentCard.getIn(['alias', 'current']);
                const cardNumber = getLastNChars(immCurrentCard.get('number'));
                const typeText = formatText(`cards-${immCurrentCard.get('type')}`)
                const label = `${aliasText} ${cardNumber} ${HYPHEN} ${typeText}`;
                optionsArr.push({
                    label,
                    value: immCurrentCard.get('cardId'),
                });
            }
        });
        const isDisabled = optionsArr.length === 1;
        const isEmtpyState = immTransactions.get('byOrder').size === 0;
        const contentClasses = classnames('col-xs-12', {
            'card-last-movements-content__content-section--empty': isEmtpyState
        });
        return (
            <div className="row">
                <div className="col-xs-6 card-last-movements-content__cards-dropdown">
                    <OKSelect
                        clearable={false}
                        disabled={isDisabled}
                        label="cardDeferredPurchases-dropdownTitle"
                        name="cards-dropdown"
                        onChange={this.handleCardsDropdownChange}
                        options={optionsArr}
                        searchable={false}
                        value={immCard.get('cardId')}
                    />
                </div>
                <div className={contentClasses}>{pageContent}</div>
            </div>
        );
    }

    buildTableElementSection() {
        const { immTransactions, defaultLanguage, immCard, immCardsTransactionsDownload } = this.props;
        return (
            <React.Fragment>
                <CardLastMovementsTable
                    immCard={immCard}
                    immTransactions={immTransactions}
                    defaultLanguage={defaultLanguage}
                />
                {immCardsTransactionsDownload.get('scaRequiredToDownload')? this.buildScaDownloadCardTransactions(): this.buildSca()}
            </React.Fragment>
        )
    }

    buildSca() {
        const { immProfile, validateAndExecuteSagas, immTransactions } = this.props;
        return (
            <Sca
                ref={this.sca}
                onHandlePostRequest={this.handlePostRequest}
                immProfile={immProfile}
                immTransactions={immTransactions}
                validateAndExecuteSagas={validateAndExecuteSagas}
            />
        )
    }

    buildScaDownloadCardTransactions() {
        const { immCardsTransactionsDownload, immTransactions, immProfile, validateAndExecuteSagas, resetScaForCardTransactionsDownload } = this.props;

        return(
            <ScaDownloadMovements
                onHandlePostRequest={this.handlePostRequestForDowloadingMovements}
                resetScaForAccountTransactionsDownload={resetScaForCardTransactionsDownload}
                immProfile={immProfile}
                immTransactions={immTransactions}
                scaRequiredForDownloadTransactions={immCardsTransactionsDownload.get('scaRequiredToDownload')}
                validateAndExecuteSagas={validateAndExecuteSagas}
            />
        )
    }

    handlePostRequestForDowloadingMovements = () => {
        const { resetScaForCardTransactionsDownload, immCardsTransactionsDownload } = this.props;

        immCardsTransactionsDownload.get('fileFormat') === CHECK_TYPES_FILE.PDF? this.cardsTransactionsDownloadAsPDF() : this.cardsTransactionsDownloadAsXLS();
        resetScaForCardTransactionsDownload();
    }

    cardsTransactionsDownloadAsPDF() {
        const { downloadCardsTransactions, immCard } = this.props;
        downloadCardsTransactions(immCard.get('cardId'), CHECK_TYPES_FILE.PDF);
    }

    cardsTransactionsDownloadAsXLS() {
        const { downloadCardsTransactions, immCard } = this.props;
        downloadCardsTransactions(immCard.get('cardId'), CHECK_TYPES_FILE.XLS);
    }

    handleNextPage() {
        const {
            flagBasedFeatures,
            immCard,
            immTransactions,
            requestNextCardTransactionsPage,
        } = this.props;

        flagBasedFeatures.get(LAVANDA) && recordLink(window.utag_last_name, MORE_MOVEMENTS_ACTION_EVENT, MORE_MOVEMENTS_EVENT_TAG);
        if (immTransactions.get('scaRequired')) {
            this.sca.current.newMovementsRequest();
        } else {
            requestNextCardTransactionsPage(immCard.get('cardId'));
        }
    }

    handleToggleDownloadModal() {
        const { downloadModalOpen } = this.state;
        this.setState({
            downloadModalOpen: !downloadModalOpen
        });
    }

    handleOpenPDFViewer() {
        const { downloadCardsTransactions, immCard } = this.props;
        downloadCardsTransactions(immCard.get('cardId'), 'PDF', VIEWER);
    }

    handleCardsDropdownChange({ value: cardId }) {
        this.props.history.push(`/myprofile/cards/${cardId}/deferred-purchases`);
    }

    handlePostRequest() {
        const {
            immCard,
            immTransactions,
            requestCardTransactions,
            requestNextCardTransactionsPage
        } = this.props;

        const isInitialRequest = immTransactions && immTransactions.getIn(['repagination', 'indPosCursorRepo']);
        const cardId = immCard.get('cardId');

        isInitialRequest === '' ? requestCardTransactions(cardId) : requestNextCardTransactionsPage(cardId);
    }

    render() {
        const {
            clearFilters,
            immFilters,
            immTransactions,
            onFilterClick,
            resetFilter,
            showCardsDropdown,
        } = this.props;

        const loading = !immTransactions || immTransactions.get('loading');
        const empty = immTransactions && immTransactions.get('byOrder').size === 0;
        const error = immTransactions && immTransactions.get('error');

        let nextPageLoadingSection;
        let nextPageButton;
        let tableContent;
        let downloadButton;

        if (loading) {
            tableContent = <LoadingSection />;
        } else if (error) {
            tableContent = this.buildConectionError();
        } else if (empty) {
            const emptySection = this.buildEmptyState();
            tableContent = showCardsDropdown ? this.buildCardsDropdown(emptySection) : emptySection;
        } else {
            const tableElement = this.buildTableElementSection();
            tableContent = showCardsDropdown ? this.buildCardsDropdown(tableElement) : tableElement;
            downloadButton = this.buildDownloadButton();
            nextPageLoadingSection = immTransactions.get('isFetchingNextPage') && <LoadingSection />;
            nextPageButton = immTransactions.get('nextPage') && this.buildNextPageButton();
        }

        return (
            <div className="card-last-movements-content">
                <CardLastMovementsHeader
                    onFilterClick={onFilterClick}
                    immTransactions={immTransactions}
                    immFilters={immFilters}
                    downloadButton={downloadButton}
                />
                <CardLastMovementsContentFilters
                    clearFilters={clearFilters}
                    immFilters={immFilters}
                    immDateFilter={immFilters.get('date')}
                    immSituationFilter={immFilters.get('situation')}
                    immStateFilter={immFilters.get('state')}
                    immTextFilter={immFilters.get('description')}
                    immAmountFilter={immFilters.get('amount')}
                    immTransactions={immTransactions}
                    resetFilter={resetFilter}
                    showStateFilter={!showCardsDropdown}
                />
                {tableContent}
                {nextPageLoadingSection}
                <div className="card-last-movements-content__actions row no-gutter">
                    <div className="col-xs-12">
                        {nextPageButton}
                    </div>
                </div>
                <DownloadFileModal
                    isOpen={this.state.downloadModalOpen}
                    onToggleDownloadModal={this.handleToggleDownloadModal}
                    title="cardDownloadModal-title"
                    mainMessage="cardDownloadModal-mainMessage"
                    firstOptionText="downloadFileModal-downloadAsPDF"
                    secondOptionText="downloadFileModal-downloadAsXLS"
                    firstOptionHandler={this.cardsTransactionsDownloadAsPDF}
                    secondOptionHandler={this.cardsTransactionsDownloadAsXLS}
                />
            </div>
        );
    }
}

CardLastMovementsContent.defaultProps = {
    showCardsDropdown: false,
}

CardLastMovementsContent.propTypes = {
    clearFilters: PropTypes.func,
    defaultLanguage: PropTypes.string,
    downloadCardsTransactions: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object,
    immCards: PropTypes.object,
    immCardsTransactionsDownload: PropTypes.object.isRequired,
    immFilters: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immTransactions: PropTypes.object,
    onFilterClick: PropTypes.func,
    onRetry: PropTypes.func,
    requestCardTransactions: PropTypes.func.isRequired,
    requestNextCardTransactionsPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func,
    showCardsDropdown: PropTypes.bool,
    validateAndExecuteSagas: PropTypes.func.isRequired,
    resetScaForCardTransactionsDownload: PropTypes.func.isRequired
};

module.exports = withRouter(CardLastMovementsContent);
